import { useMemo } from 'react';

import { LookUp } from '@work4all/models/lib/Classes/LookUp.entity';
import { SortDirection } from '@work4all/models/lib/DataProvider';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';
import { LookupType } from '@work4all/models/lib/Enums/LookupType.enum';

import { LookUpProvider } from './contexts/LookUpContext';
import { EntityTableV8 } from './entity-table/EntityTableV8';
import { useEntityDataTableV8 } from './entity-table/use-entity-data-table-v8';
import { useLookUpTableSchema } from './lookup-table/LookUpTableSchema';

interface LookUpTableProps {
  lookupType: LookupType;
}

export const LookUpTable = ({ lookupType }: LookUpTableProps) => {
  // Set up prefilter to only show lookups of the specified type
  const vars = useMemo(() => {
    return {
      type: lookupType,
    };
  }, [lookupType]);

  const schema = useLookUpTableSchema(lookupType);

  const table = useEntityDataTableV8<LookUp, Record<string, never>>({
    schema,
    vars,
    enableLocalFiltering: true,
    defaultSort: [
      {
        field: 'name',
        direction: SortDirection.ASCENDING,
      },
    ],
    enableMultiRowSelection: false,
  });

  const { selectedEntities } = table;

  return (
    <LookUpProvider lookupType={lookupType}>
      <EntityTableV8
        hideMoreButton
        entityType={Entities.lookUp}
        settingsEntityType={Entities.lookUp}
        table={table.table}
        selectedEntities={selectedEntities}
        fetchMore={table.fetchMore}
        pending={table.pending}
        areas={{
          left: null,
        }}
      />
    </LookUpProvider>
  );
};
